let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aeKAW")).then(() => parcelRequire('j6pF4'));